// extracted by mini-css-extract-plugin
export default {"app":"App_app__nQhRp","background":"App_background__c1qtp","logoBack":"App_logoBack__W7ZYk"};